// This file is generated by NTypewriter using scriban template (_Models.nt), DO NOT MODIFY THIS FILE
/* tslint:disable */
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { GlobalSearchResultModel } from './GlobalSearchResultModel';
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { GlobalAdvancedSearchInputModel } from './GlobalAdvancedSearchInputModel';
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { ItemSearchModel } from './ItemSearchModel';

/**
 * Provides an aggregated search across all document types 
 */
export class SearchServiceClient {

    /**
     * get: Find?query=${encodeURIComponent(query)}
     */
    public static RouteFind = (query: string) => `/Find?query=${encodeURIComponent(query)}`;
    /**
     * 
     */
    public static async find(query: string): Promise<GlobalSearchResultModel> {
        const url = SearchServiceClient.RouteFind(query);
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * get: FindUnpublished
     */
    public static RouteFindUnpublished = () => `/FindUnpublished`;
    /**
     * 
     */
    public static async findUnpublished(): Promise<GlobalSearchResultModel> {
        const url = SearchServiceClient.RouteFindUnpublished();
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: FindAdvanced
     */
    public static RouteFindAdvanced = () => `/FindAdvanced`;
    /**
     * 
     */
    public static async findAdvanced(input: GlobalAdvancedSearchInputModel): Promise<GlobalSearchResultModel> {
        const url = SearchServiceClient.RouteFindAdvanced();
        const method: string = 'post';
        const data: any = input;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: FindAdvancedDeleted
     */
    public static RouteFindAdvancedDeleted = () => `/FindAdvancedDeleted`;
    /**
     * 
     */
    public static async findAdvancedDeleted(input: GlobalAdvancedSearchInputModel): Promise<GlobalSearchResultModel> {
        const url = SearchServiceClient.RouteFindAdvancedDeleted();
        const method: string = 'post';
        const data: any = input;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

}

/**
 * Provides an aggregated search across all document types 
 */
export class SearchRequestFactory {

    /**
     * get: Find?query=${encodeURIComponent(query)}
     */
    public static RouteFind = (query: string) => `/Find?query=${encodeURIComponent(query)}`;
    /**
     * 
     */
    public static async find(fetcher: (url: string, init: RequestInit) => Promise<Response>, query: string): Promise<GlobalSearchResultModel> {
        const url = SearchServiceClient.RouteFind(query);
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * get: FindUnpublished
     */
    public static RouteFindUnpublished = () => `/FindUnpublished`;
    /**
     * 
     */
    public static async findUnpublished(fetcher: (url: string, init: RequestInit) => Promise<Response>, ): Promise<GlobalSearchResultModel> {
        const url = SearchServiceClient.RouteFindUnpublished();
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: FindAdvanced
     */
    public static RouteFindAdvanced = () => `/FindAdvanced`;
    /**
     * 
     */
    public static async findAdvanced(fetcher: (url: string, init: RequestInit) => Promise<Response>, input: GlobalAdvancedSearchInputModel): Promise<GlobalSearchResultModel> {
        const url = SearchServiceClient.RouteFindAdvanced();
        const method: string = 'post';
        const data: any = input;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: FindAdvancedDeleted
     */
    public static RouteFindAdvancedDeleted = () => `/FindAdvancedDeleted`;
    /**
     * 
     */
    public static async findAdvancedDeleted(fetcher: (url: string, init: RequestInit) => Promise<Response>, input: GlobalAdvancedSearchInputModel): Promise<GlobalSearchResultModel> {
        const url = SearchServiceClient.RouteFindAdvancedDeleted();
        const method: string = 'post';
        const data: any = input;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

}


// WEBPACK FOOTER //
// ./src/model/autogen/SearchController.ts